const AUTH_API = {
  LOGIN: "/Auth/Login",
  REGISTER: "/Auth/Register",
  PROFILE: "/auth/profile",
  FORGOT_PASSWORD: "/Auth/ForgotPassword",
  VERIFYOTP: "/Auth/VerifyOTP",
  SETPASSWORD: "/Auth/SetPassword",
  getUserDetails: "/Users/UserDetail",
  updateUserProfile: "/Users/User",
};

export default AUTH_API;
